export default __webpack_public_path__ + "static/media/pic8.68329d08.jpg";